import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useTheme } from "next-themes";
import { Check, MonitorCog, Moon, Palette, Sun } from "lucide-react";
import HeatFlowSettingCard from "@/components/account/HeatFlowSettingCard";
import HapticsSettingCard from "@/components/account/HapticsSettingCard";
import ProtocolDefaultViewSettingCard from "@/components/account/ProtocolDefaultViewSettingCard";

function ThemeOption({ active, caption, icon: Icon, label, onClick }) {
  return (
    <Button
      type="button"
      variant="ghost"
      onClick={onClick}
      data-active={active ? "true" : "false"}
      className="native-v3-theme-option"
    >
      <span className="native-v3-theme-option-icon"><Icon aria-hidden="true" /></span>
      <strong>{label}</strong>
      <small>{caption}</small>
      <i aria-hidden="true">{active ? <Check /> : null}</i>
    </Button>
  );
}

export default function AppearancePanel() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Palette className="h-5 w-5 shrink-0 opacity-70" />
            <span>Tema & visning</span>
          </CardTitle>
          <CardDescription>
            Välj hur appen ska visas och anpassa känslan i protokollflödet.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="native-v3-theme-selector">
            <div>
              <ThemeOption active={theme === "light"} caption="Ljust gränssnitt" icon={Sun} label="Ljus" onClick={() => setTheme("light")} />
              <ThemeOption active={theme === "dark"} caption="Mörkt gränssnitt" icon={Moon} label="Mörk" onClick={() => setTheme("dark")} />
              <ThemeOption
                active={theme === "system"}
                caption="Följ enheten"
                icon={MonitorCog}
                label="System"
                onClick={() => setTheme("system")}
              />
            </div>
          </div>
          {/* <p className="text-sm text-muted-foreground">
            System följer enhetens inställning automatiskt.
          </p> */}
        </CardContent>
      </Card>

      <ProtocolDefaultViewSettingCard />
      <HeatFlowSettingCard />
      <HapticsSettingCard />
    </div>
  );
}
